import { message, Spin, Button, Result } from "antd";
import React, { useCallback, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { FirebaseAuth } from "../../../utils/firebase";
import { signInWithEmailLink } from "../firebase";
import { LoginForm } from "./loginForm";
import { LoginLayout } from "./loginLayout";
import firebase from "firebase/app";
import { useLocation } from "react-router-dom";
import queryString from "query-string";

const FirebaseLoginVerify = () => {
  const location = useLocation();
  const qs = queryString.parse(location.search);
  const { keepMeLogin } = qs;

  const [email, setEmail] = useState(qs.email);
  const [loading, setLoading] = useState(false);
  const [keepLoginInfo, setKeepLoginInfo] = useState(true);
  const [verificationFailed, setVerificationFailed] = useState(false);
  const [isEmailInvalidError, setIsEmailInvalidError] = useState(false);
  const [verificationError, setVerificationError] = useState("");
  const { isLoggingIn } = useSelector((state) => state.session);

  useEffect(() => {
    if (keepMeLogin === "false") {
      setKeepLoginInfo(false);
    }
  }, []);
  const verifyEmail = useCallback(async (emailToVerify) => {
    setLoading(true);
    const result = await signInWithEmailLink(emailToVerify);
    if (result.error) {
      message.error(result.error);
      setVerificationFailed(true);
      if (result.code === "auth/invalid-email") {
        setIsEmailInvalidError(true);
      }
      setVerificationError(result.error);
      setLoading(false);
      return;
    } else {
      if (keepLoginInfo) {
        FirebaseAuth.setPersistence(firebase.auth.Auth.Persistence.LOCAL);
      } else {
        FirebaseAuth.setPersistence(firebase.auth.Auth.Persistence.SESSION);
      }
    }

    setLoading(false);
  }, []);

  const tryAgain = () => {
    setVerificationFailed(false);
    setIsEmailInvalidError(false);
    setVerificationError("");
  };

  useEffect(() => {
    if (email) {
      verifyEmail(email);
    }
  }, [verifyEmail]);

  const onSubmit = async () => {
    if (!email) {
      message.error("Invalid email");
      setLoading(false);
      return;
    }
    verifyEmail(email);
  };

  return (
    <LoginLayout>
      {verificationFailed ? (
        <Result
          status="warning"
          title={verificationError}
          subTitle={
            isEmailInvalidError
              ? "Try again with correct Email ID"
              : "Please go to the login page to re-create login link"
          }
          extra={
            isEmailInvalidError ? (
              <Button type="primary" key="try-again" onClick={tryAgain}>
                Try Again
              </Button>
            ) : (
              <Button type="primary" key="login" href="/">
                Go to Login Page
              </Button>
            )
          }
        />
      ) : (
        <Spin spinning={loading || isLoggingIn} tip="Signing In...">
          <LoginForm
            email={email}
            setEmail={setEmail}
            onSubmit={onSubmit}
            verifyingEmail={true}
            disabled={verificationFailed}
            setKeepMeLogin={setKeepLoginInfo}
            keepMeLogin={keepLoginInfo}
          />
        </Spin>
      )}
    </LoginLayout>
  );
};

export { FirebaseLoginVerify };
